var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"is-fluid columns is-fullheight is-flex local-lm-global-dashboard"},[_c('div',{staticClass:"column is-1 local-lm-left-menu"},[_c('left-menu')],1),_vm._v(" "),_c('div',{staticClass:"column is-11 local-lm-main"},[_c('top-menu'),_vm._v(" "),_c('div',{staticClass:"section"},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eefcc60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = null
// module chunks = 